import { Link } from 'react-router-dom';

// items: [{ key, name, Icon, color, value, link? }]
export const CategoryRanking = ({ items = [], total = 0, barsIn = true }) => {
  const max = items[0]?.value || 1;
  return (
    <div className="space-y-3">
      {items.map((c) => {
        const pct = total ? (c.value / total) * 100 : 0;
        const barPct = barsIn ? (c.value / max) * 100 : 0;
        const Wrapper = c.link ? Link : 'div';
        const wProps = c.link ? { to: c.link } : {};
        return (
          <Wrapper
            key={c.key}
            {...wProps}
            data-testid={`category-item-${String(c.key).replace(/_/g, '-')}`}
            className="flex items-center gap-3 rounded-lg -mx-2 px-2 py-1 hover:bg-muted/50 transition-colors"
          >
            <span
              className="flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center"
              style={{ backgroundColor: `${c.color}1a`, color: c.color }}
            >
              <c.Icon className="h-4 w-4" strokeWidth={1.5} />
            </span>
            <span className="text-sm text-foreground w-24 sm:w-32 flex-shrink-0 truncate">{c.name}</span>
            <div className="flex-1 h-2.5 bg-muted/60 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-700 ease-out"
                style={{ width: `${barPct}%`, backgroundColor: c.color }}
              />
            </div>
            <span className="text-sm font-semibold text-foreground font-mono tabular-nums w-10 text-right">{c.value}</span>
            <span className="text-xs text-muted-foreground font-mono w-12 text-right">{pct.toFixed(1)}%</span>
          </Wrapper>
        );
      })}
    </div>
  );
};
